<template>
  <!-- OUTER WRAPPER -->
  <div class="relative min-h-screen flex items-center justify-center overflow-hidden py-12">

    <!-- VECTOR IMAGE (ABOVE GRAY, BELOW CARD) -->

    <!-- WHITE CARD (TOP LAYER) -->
    <div class="relative z-20 w-full max-w-5xl mx-auto px-4">
      <div v-reveal class="card overflow-hidden flex flex-col md:flex-row">
        <div class="md:w-1/2 flex justify-center items-center p-8 md:p-10 bg-gradient-to-br from-brand-cream/40 to-white">
          <img src="../assets/images/contact.jpg" alt="Contact Vector" class="w-full max-w-sm h-auto object-contain mix-blend-multiply" />
        </div>
        <!-- LEFT IMAGE / FORM SIDE -->
        <div class="md:w-1/2 p-6 sm:p-8 md:p-10 w-full">
          <h2 class="font-serif text-3xl font-bold text-gray-900 mb-1">
            Contact Us
          </h2>
          <div class="w-12 h-1 rounded-full bg-brand-red mb-7 mt-3"></div>

          <form @submit.prevent="handleSubmit" class="space-y-4">
            <div>
              <label class="form-label">Name</label>
              <input
                v-model="form.name"
                type="text"
                class="form-input"
                required
              />
            </div>

            <div>
              <label class="form-label">Email</label>
              <input
                v-model="form.email"
                type="email"
                class="form-input"
                required
              />
            </div>

            <div>
              <label class="form-label">Contact</label>
              <input
                v-model="form.contact"
                type="tel"
                class="form-input"
                required
              />
            </div>

            <div>
              <label class="form-label">Message</label>
              <textarea
                v-model="form.message"
                rows="4"
                class="form-input resize-y"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              class="btn-cream w-full py-3 !mt-6"
            >
              <i class="fa-regular fa-paper-plane text-xs"></i>
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Swal from 'sweetalert2'
export default {
  name: 'ContactForm',
  data() {
  
    return {
      form: {
        name: '',
        email: '',
        contact: '',
        message: ''
      }
    
  }
  },
  methods: {
    async handleSubmit() {
      // ✅ Use your live API base URL (fallback to localhost for dev)
      const API_BASE_URL =
        process.env.VUE_APP_API_BASE_URL || 'https://sanskritirdapoon.in/api';

      try {
        const response = await fetch(`${API_BASE_URL}/contact`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.form)
        });

        if (response.ok) {
          Swal.fire({
            icon: 'success',
            title: 'Sent!',
            text: 'Message sent successfully!',
            confirmButtonColor: '#BF3131'
          });
          // ✅ Reset form after successful submission
          this.form = { name: '', email: '', contact: '', message: '' };
        } else {
          const errorData = await response.text();
          console.error('Backend error:', errorData);
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Failed to send message. Please try again.',
            confirmButtonColor: '#BF3131'
          });
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred. Please try again later.',
          confirmButtonColor: '#BF3131'
        });
      }
    }
  }
}
</script>
